import { Stack } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DashboardCard } from "./DashboardCard"

export const Dashboard = () => {
  return (
    <Frame title="Dashboard">
      <Stack direction="row" spacing={4}>
        <DashboardCard backgroundColor="#C1E6ED" title="Total Hits" value="13,176,294" />
        <DashboardCard backgroundColor="#E1CF2E" title="Avg. Interaction Time " value="3m 47s" />
        <DashboardCard backgroundColor="#6FCD9A" title="Total Tagged Products" value="976" />
      </Stack>
    </Frame>
  )
}
